import { authApi } from './api';

export const login = async (username: string, password: string) => {
  try {
    const response = await authApi.login({ username, password });
    return response;
  } catch (error) {
    console.error('[AuthService] Login error:', error);
    throw error;
  }
};

export const register = async (email: string, password: string, name: string) => {
  try {
    // Por enquanto, vamos usar o login como fallback para register
    // TODO: Implementar endpoint de register no backend
    const response = await authApi.login({ username: email, password });
    return response;
  } catch (error) {
    console.error('[AuthService] Register error:', error);
    throw error;
  }
}; 